<template>
  <section>
    
    <b-overlay :show="loading" rounded="sm">
        <button
           :disabled="!checkAccepted"
          v-on:click="inviteSubmit"
          class="btn btn-fill mt-2 btn-block btn-primary"
        >
          <img class="authIcon" src="/img/auth/net-id-enterprise.png" :alt="$t('AUTH_METHODS.net-id-enterprise')"  /> {{ $t("START") }} {{ $t('AUTH_METHODS.net-id-enterprise') }}
        </button>

    </b-overlay>
  </section>
</template>
<script>
export default {
  props: ["accepted", "code"],
  data() {
    return {
      loading: true,
      auth_uuid: "",
      errorMessage: "",
    };
  },
  methods: {
    inviteSubmit: function() {
      this.loading = true;
      this.$emit("loading", true);
      let self = this;
      this.$http
        .post(this.user.hostname + "/invite/activate", {
          code: this.code,
          method: "net-id-enterprise"
        })
        .then(function(result) {
          if(result.data.redirect == 1)
          {
            self.redirect = true;
            window.location.href = result.data.request_url;
          }else{
            self.auth_uuid = result.data.auth_uuid;
            self.makeRequest(result.data.request_url);
            self.$emit('setaccess', false);
          }
        })
        .catch(function() {
          this.$emit("loading", false);
          self.$noty.error(self.$t("ERROR.CANNOT_LOGIN"));
        });
    },
    makeRequest: function(url) {
      this.loading = true;
      let self = this;
      this.$http
        .get(url)
        .then(function() {
          self.verifyAuthentication();
        })
        .catch(function() {
          self.loading = false;
          self.$emit('setaccess', true);
          self.$noty.error(self.$t("ERROR.CANNOT_LOGIN_WITH_CERTIFICATE"));
        });
    },
    verifyAuthentication: function() {
      let self = this;
      this.$http
        .get(this.user.hostname + "/authenticate/result/" + this.auth_uuid)
        .then(function(result) {
          self.$emit("activated", result.data.token);
        })
        .catch(function() {
          self.$emit('setaccess', true);
          self.$emit("loading", false);
          self.$noty.error(self.$t("ERROR.CANNOT_LOGIN_WITH_CERTIFICATE"));
          self.loading = false;
        });
    },
  },
  computed: {
    showBack() {
      return this.authentication_method == null && this.auth_method == "";
    },
    checkAccepted() {
      return this.accepted == 1;
    },
  },
  mounted: function() {
    this.loading = false;
  },
};
</script>
<style></style>
